<template>
  <VModal :isActive="isActive" @clickModal="cancel">
    <transition name="item">
      <div class="form" v-if="isActive">
        <VInput v-model="newLink.name" placeholder="name" /><br />
        <VInput v-model="newLink.color" placeholder="color" /><br />
        <VSelect v-model="newLink.pattern" placeholder="Select line pattern">
          <option value="solid" selected>Solid</option>
          <option value="dash">Dash</option>
          <option value="dot">Dot</option> </VSelect
        ><br />
        <VSelect v-model="newLink.arrow" placeholder="Select arrow type">
          <option value="none">none</option>
          <option value="src">One side(source)</option>
          <option value="dest" selected>One side(destination)</option>
          <option value="both">Both side</option> </VSelect
        ><br />
        <VInput v-model="newLink.rule" placeholder="e.g. context.amount > 100" /><br />
        <b-button variant="success" size="sm" @click="ok">OK</b-button>
        <b-button variant="danger" size="sm" @click="cancel">Cancel</b-button>
      </div>
    </transition>
  </VModal>
</template>
<script>
export default {
  props: {
    isActive: Boolean,
    link: {
      type: Object,
      default() {
        return {
          id: "0",
          content: {
            color: "#1890ff",
            pattern: "solid",
            arrow: "dest",
            name: '',
            rule: ''
          }
        };
      }
    }
  },
  computed: {
    newLink: {
      get() {
        return this.link.content;
      }
    }
  },
  methods: {
    ok() {
      this.$emit("ok", {
        id: this.link.id,
        content: {
          color: this.newLink.color,
          pattern: this.newLink.pattern,
          arrow: this.newLink.arrow,
          name: this.newLink.name,
          rule: this.newLink.rule
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  margin-bottom: 5px;
}
.item-enter-active {
  transition: all 0.8s ease;
}
.item-leave-active {
  transition: all 0.3s ease;
}
.item-enter,
.item-leave-to {
  opacity: 0;
}
select {
  margin-bottom: 5px;
}
</style>
